module.exports = __webpack_public_path__ + "img/car_rent_baner_detail.03bafdc9.jpg";